import { initNav } from "./nav.js";
import { initPartials, initHead } from "./partials.js";
import { initCarousel } from "./carousel.js";
import { initTabs } from "./tabs.js";
import { initRevealAnimations } from "./reveal.js";

// Initialize head partial first (loads common head content and sets title)
initHead().then(() => {
  return initPartials();
}).then(() => {
  initNav();
  if (document.querySelector("[data-carousel]")) {
    const checkDependencies = () => {
      if (typeof window.$ !== "undefined" && typeof window.$.fn.slick !== "undefined") {
        initCarousel();
      } else {
        setTimeout(checkDependencies, 50);
      }
    };
    checkDependencies();
  }
  initTabs();
  initRevealAnimations();
});
